import { Icon } from '../../components/templates/icons';

// Empty-state CTA + AddSection button + the small SectionNameForm shared by
// both. Lifted out of DeficiencyLibraryPage.tsx during the 2026-05-01 split.

interface EmptyStateProps {
  onCreate: () => void;
  creating: boolean;
  draft: string;
  setDraft: (v: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export function EmptyState({ onCreate, creating, draft, setDraft, onSubmit, onCancel }: EmptyStateProps) {
  if (creating) {
    return (
      <div className="dl-empty">
        <div className="dl-empty-title">Name the section</div>
        <div className="dl-empty-text">
          Use the same names you use in your template — e.g. <em>Roof</em>,{' '}
          <em>Exterior</em>, <em>Kitchen</em>.
        </div>
        <SectionNameForm
          value={draft}
          onChange={setDraft}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      </div>
    );
  }
  return (
    <div className="dl-empty">
      <div className="dl-empty-title">Your library is empty</div>
      <div className="dl-empty-text">
        Create a section to group related observations — your chips will appear under this
        name during field capture.
      </div>
      <button type="button" className="ts-btn ts-btn--primary" onClick={onCreate}>
        <Icon name="plus" size={12} /> New section
      </button>
    </div>
  );
}

interface AddSectionProps {
  creating: boolean;
  draft: string;
  setDraft: (v: string) => void;
  onStart: () => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export function AddSection({ creating, draft, setDraft, onStart, onSubmit, onCancel }: AddSectionProps) {
  if (creating) {
    return (
      <div className="dl-add-section">
        <SectionNameForm
          value={draft}
          onChange={setDraft}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      </div>
    );
  }
  return (
    <button type="button" className="dl-add-section-btn" onClick={onStart}>
      <Icon name="plus" size={12} /> New section
    </button>
  );
}

function SectionNameForm({
  value,
  onChange,
  onSubmit,
  onCancel,
}: {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
}) {
  return (
    <form
      className="dl-section-form"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <input
        className="dl-input"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Section name"
        autoFocus
      />
      <div className="dl-section-form-actions">
        <button type="submit" className="ts-btn ts-btn--primary ts-btn--sm" disabled={!value.trim()}>
          Create
        </button>
        <button type="button" className="ts-btn ts-btn--secondary ts-btn--sm" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
}
